import { Component, Input, OnChanges, ChangeDetectorRef, SimpleChanges, inject } from '@angular/core';
import {Chart, ChartType, ChartDataset, ChartEvent} from 'chart.js';
import { NWMChartSettings } from './NWMChartSettings';
import { tooltipType } from "app/components/NWMCharts/NWMCharts.module";
import { APIService } from 'app/services/api.service';
import {Router} from "@angular/router";
import { BaseChartDirective } from 'ng2-charts';

type chartEventType = {event?: ChartEvent; active?: object[] };


type doughnutChartData = {
  Label: string[];
  BackgroundColor: string[];
  Data: number[];
  Link: string[];
}

@Component({
    selector: 'NWMDoughnutChart',
    templateUrl: './nwmdoughnutchart.component.html',
    styleUrls: ['./nwmchart.component.scss'],
    imports: [BaseChartDirective]
})

export class NWMDoughnutChartComponent implements OnChanges {
  private api = inject(APIService);
  private router = inject(Router);
  private ref = inject(ChangeDetectorRef);

  @Input() data: doughnutChartData = {
    Label: [],
    BackgroundColor: [],
    Data: [],
    Link: []
  };
  @Input() height: number = 280;

  public chartData: ChartDataset[] = [{data:[],backgroundColor:[]}];
  public chartType: ChartType = 'doughnut';
  public chartLabels: string[] = [];
  public chartLegend = false;
  public tooltip: tooltipType = {visible:false, rows:[]};
  public chartSettings: NWMChartSettings;
  public valuationDate = '';
  public dataLoaded = true;

  constructor() {
    this.chartSettings = new NWMChartSettings();

  }

  ngOnChanges(changes: SimpleChanges): void {

    this.dataLoaded = false;
    this.tooltip.visible = false;
    this.chartSettings.options.plugins = {tooltip:{enabled: false, external: (a)=>this.customTooltip(a.chart)}};
    this.chartSettings.options.scales = undefined;
    this.chartSettings.options.elements = {arc: {borderWidth: 0}};

    if (Object.prototype.hasOwnProperty.call(changes,'data')) {
      this.data.Data.forEach((a) => {
        this.chartData[0].data.push(a);
      });
      this.chartData[0].backgroundColor = this.data.BackgroundColor;
      this.chartLabels = this.data.Label;
      this.dataLoaded = true;
    }
  }

  customTooltip(chart: Chart): void {
    const tooltipModel = chart.tooltip!;
    this.tooltip.visible = tooltipModel.opacity !== 0;
    if (tooltipModel.body) {
      const i = tooltipModel.dataPoints[0].dataIndex;
      this.tooltip.rows = [
        { key: this.data!.Label[i] , value: '' },
      ];
    }
    setTimeout(()=>{this.ref.detectChanges();});
  }
  chartClicked(e: chartEventType) {
    const i = (e.active![0] as {index:number}).index;
    if (e.active && e.active[0] && this.data!.Link[i]) {
      this.router.navigate([this.data!.Link[i]]);
    }
  }



}
